import { Image } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { FC } from 'react'

type RolexPushBannerImageProps = {
  gridLayout: 'n1_column' | 'n2_columns' | 'n3_columns'
  mobileImage: AssetsElement
  desktopImage: AssetsElement
}

export const RolexPushBannerImage: FC<RolexPushBannerImageProps> = ({
  mobileImage,
  desktopImage,
  gridLayout,
}) => {
  return (
    <Image
      className={cn(
        'aspect-video opacity-100 transition-opacity duration-150 group-hover:opacity-80',
        gridLayout === 'n2_columns' && 'aspect-square md:aspect-video',
        gridLayout === 'n1_column' && 'aspect-square md:aspect-video lg:aspect-[3/1]',
      )}
      sources={[
        getKontentImage(mobileImage.value[0]?.url, {
          width: 768,
        }),
        getKontentImage(mobileImage.value[0]?.url, {
          width: 768,
        }),
        getKontentImage(desktopImage.value[0]?.url, {
          width: 1600,
        }),
      ]}
      alt={desktopImage.value[0]?.description as string}
    />
  )
}
